export default {
  FETCH_COUNTS_START: 'CALENDAR.FETCH_COUNTS_START',
  FETCH_COUNTS_SUCCESS: 'CALENDAR.FETCH_COUNTS_SUCCESS',
  FETCH_COUNTS_FAILURE: 'CALENDAR.FETCH_COUNTS_FAILURE',
}
